









































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import Empty from "@/components/empty.vue";
import { GetBanjiList, EditBanji, DelBanji } from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
    Empty,
  },
})
export default class Name extends Vue {
  private data: any = [];
  private ifShowEdit: any = false;
  private editData: any = {};
  private ifShowEmpty: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private changeStatus(item: any) {
    this.$confirm(
      `您确定要${item["状态"] == "正常" ? "禁用" : "启用"}该班级么？`,
      `${item["状态"] == "正常" ? "禁用" : "启用"}`,
      {
        customClass: "commonConfirm",
        confirmButtonClass: "iconfont icon-anniu4 confirmSure",
        cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
      }
    ).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      item["状态"] = item["状态"] == "正常" ? "禁用" : "正常";
      EditBanji(this, item, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success(
            `${item["状态"] == "正常" ? "启用" : "禁用"}成功`
          );
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            banji_id: item.banji_id,
          },
        };
        DelBanji(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private openEdit(item?: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {
        名称: "",
        student_ids: [],
        状态: "正常",
      };
    }
    this.ifShowEdit = true;
  }
  private addSure() {
    if (!this.editData["名称"]) {
      this.$message.warning("请输入班级名称");
      return;
    }
    if (
      !this.editData["实训练习范围"] ||
      this.editData["实训练习范围"].length == 0
    ) {
      this.$message.warning("请选择实训练习范围");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditBanji(this, this.editData, loading)
      .then((res: any) => {
        loading.close();
        if (this.editData.banji_id) {
          this.$message.success("编辑成功");
        } else {
          this.$message.success("添加成功");
        }
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      page_count: 0,
      order_key: "create_time",
      order_value: -1,
    };
    GetBanjiList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private goStudent(item: any) {
    this.$router.push({
      path: "/main/teacher/class-student",
      query: {
        data: JSON.stringify(item),
      },
    });
  }
  mounted() {
    this.getList();
  }
}
